import { createUseStyles } from "react-jss";
import {colors} from "../../../../constants/colors";

const styles = createUseStyles(theme => ({
  verifyEmail: {
    margin: "20px 0 0 0"
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  checkbox: {
    marginRight: "12px"
  },

  btnContainer:{
    marginTop:"32px",
    marginBottom:"16px"
  },

  cancelBtn: {
    height: "100%",
    alignItems: "center",
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  createBtn: {
    height: "100%",
    alignItems: "center",
    width:"100%",
    justifyContent:"center",
    fontSize: "16px",
    fontWeight:"600",
    lineHeight:"20px",
    fontFamily: theme.fontFamily,
  },
  colCancel:{
    padding:"0px",
    marginRight:"6px"
  },
  colRemove:{
    padding:"0px",
    marginLeft:"6px"
  },
  digits: {
    display: "flex"
  },
  digit: {
    width: "80px",
    height: "80px",
    border: "2px solid " + theme.field.borderColor,
    borderRadius: "8px",
    "&:not(:last-child)": {
      marginRight: "12px",
    },
    "&.active": {
      border: "2px solid " + theme.field.borderColorActive,
    },
    "& input": {
      padding: "0px",
      width: "100%",
      height: "100%",
      border: "none",
      outline: "none",
      borderRadius: "8px",
      fontSize: "48px",
      fontWeight: "500",
      color: colors.darkBlue,
      textAlign: "center",
      caretColor: "transparent",
      "MozAppearance": "textfield",
      "&::-webkit-inner-spin-button": {
        appearance: "none",
        "WebkitAppearance": "none",
        "MozAppearance": "textfield",
        margin: "0"
      },
      "&::-webkit-outer-spin-button": {
        appearance: "none",
        "WebkitAppearance": "none",
        "MozAppearance": "textfield",
        margin: "0"
      },
      "&::placeholder": {
        color: colors.darkGrey
      }
    }
  },
  didntReceive: {
    fontSize: "14px",
    fontWeight:"400",
    color: colors.mediumGrey,
    maxWidth:"360px",
    textAlign:"left",
    marginTop: "6px"
  },
  resendBtn: {
    color: colors.mediumGrey,
    padding:"0px",
    marginLeft: "4px",
    cursor: "pointer",
    fontWeight: "400",
    border: "none",
    textDecoration: "underline",
    backgroundColor: "inherit"
  },
  emailError: {
    fontSize: "14px",
    fontWeight:"400",
    color: colors.red,
    marginTop: "6px"
  }


}));

export default styles;
